<template>
    <div v-if="isLoggedIn && appParams && appParams.staticTranslations">
        <div class="itb-saved-carts container">
            <span class="itb-saved-carts-back"></span>
            <router-link :to="'/saved-carts'">
                {{ appParams.staticTranslations["carts.saved_carts"] }}
            </router-link>

            <div v-if="message" class="container">
                <div class="row">
                    <div
                        class="col-12 col-sm-8 offset-sm-2 col-md-4 col-lg-4 offset-md-4 offset-lg-4 pt-3 mb-5 text-center"
                    >
                        <div
                            :class="'alert itb-alert alert-' + message.type"
                            role="alert"
                        >
                            {{ message.text }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="itb-saved-cart-page" v-if="showGraphicList">
            <h2 class="itb-cart-title">
                {{ appParams.staticTranslations["carts.saved_cart"] }}
                {{ cartId }}
            </h2>
            <div class="container">
                <table class="table itb-cart-graphics-list">
                    <thead>
                        <tr class="itb-table-header">
                            <th scope="col">
                                {{
                                    appParams.staticTranslations["carts.items"]
                                }}
                            </th>
                            <th scope="col">
                                {{
                                    appParams.staticTranslations["carts.weight"]
                                }}
                            </th>
                            <th scope="col">
                                {{ appParams.staticTranslations["carts.pcs"] }}
                            </th>
                            <th scope="col">
                                {{
                                    appParams.staticTranslations["carts.price"]
                                }}
                            </th>
                        </tr>
                    </thead>
                    <tbody
                        v-for="graphic in graphics"
                        class="itb-product-fields"
                    >
                        <tr class="itb-saved-cart-items">
                            <td style="width: 340px">
                                <div class="row">
                                    <div class="col-2">
                                        <img
                                            v-if="graphic.image"
                                            class="itb-cart-img"
                                            v-bind:src="
                                                '/uploads/' +
                                                graphic.image.path +
                                                '/' +
                                                graphic.image.name
                                            "
                                            v-bind:alt="graphic.name"
                                        />
                                    </div>
                                    <div class="col-10">
                                        <div class="itb-cart-table-name">
                                            <a
                                                :href="graphic.url"
                                                target="_blank"
                                            >
                                                {{ graphic.name_variant }}
                                            </a>
                                        </div>
                                        <div class="itb-cart-table-code">
                                            {{
                                                appParams.staticTranslations[
                                                    "carts.code_label"
                                                ]
                                            }}:
                                            {{ graphic.graphic_code }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="itb-cart-table-weight">
                                {{ graphic.weight }} kg
                            </td>
                            <td class="itb-cart-table-quantity">
                                {{ graphic.quantity }}
                            </td>
                            <td class="itb-cart-table-price">
                                {{ graphic.price }}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="5" class="pt-0 pl-0 pr-0 border-top-0">
                                <div class="itb-product-note-wrapper">
                                    <p
                                        v-if="graphic.note.length > 0"
                                        class="itb-product-note-text"
                                    >
                                        <strong
                                            >{{
                                                appParams.staticTranslations[
                                                    "carts.note"
                                                ]
                                            }}:</strong
                                        >&#32;{{ graphic.note }}
                                    </p>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr class="itb-cart-table-summary">
                            <td>
                                {{
                                    appParams.staticTranslations["carts.total"]
                                }}
                            </td>
                            <td>{{ totalWeight }} kg</td>
                            <td>{{ totalQuantity }}</td>
                            <td>{{ totalPrice }}</td>
                        </tr>
                    </tfoot>
                </table>
                <div class="itb-submit-btn-wrapper">
                    <button
                        type="button"
                        class="btn btn-primary itb-add-to-basket"
                        @click="addToCart"
                        style="margin-bottom: 60px"
                        :disabled="isAddDisabled"
                    >
                        {{
                            appParams.staticTranslations["carts.add_to_basket"]
                        }}&nbsp;&ensp;
                        <img
                            src="/images/cart-plus-solid.svg"
                            :alt="
                                appParams.staticTranslations[
                                    'general.submit_button'
                                ]
                            "
                            class="itb-icon itb-paperplane"
                        />
                    </button>
                </div>
            </div>
        </div>
        <div v-else class="container">
            <div class="row">
                <div
                    class="col-12 col-sm-8 offset-sm-2 col-md-4 col-lg-4 offset-md-4 offset-lg-4 pt-3 mb-5 text-center"
                >
                    <div class="alert itb-alert alert-info" role="alert">
                        {{
                            appParams.staticTranslations["carts.no_active_cart"]
                        }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            pageParams: [],
            graphics: {},
            cartId: "",
            showGraphicList: false,
            discountPercentage: 0,
            discountValue: 0,
            totalWeight: 0,
            totalPrice: 0,
            totalQuantity: 0,
            message: null,
            isAddDisabled: false,
            pohodaPriceName: "",
        };
    },

    mounted() {
        axios
            .get("/getSavedCartPage")
            .then((response) => {
                // this.heroCards = response.data.heroCards;
                this.pageParams = response.data.params;

                this.setPageParams(this.pageParams);
            })
            .catch((error) => {
                console.log(error);
            });
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams",
            isLoggedIn: "getClientLogged",
            profile: "getClientProfile",
            cartCounter: "getCartCounter",
        }),
    },

    created() {
        // when cart is accessed without being logged in, it will redirect to home
        this.logRedirect();
        this.getSelectedCart();
    },

    methods: {
        ...mapActions(["setPageParams", "setFormParams", "updateCartCounter"]),

        logRedirect() {
            if (!this.isLoggedIn) {
                if (this.$route.path != "/") {
                    this.$router.push("./");
                }
            }
        },

        getSelectedCart() {
            let cartId = this.$route.path.replace(
                "/saved-carts/carts/cart",
                ""
            );
            let cartInfo = { cart_id: cartId, client_id: this.profile.id };
            axios
                .post("/getCart", cartInfo)
                .then((response) => {
                    this.graphics = response.data;
                    if (response.data.length > 0) {
                        this.cartId = response.data[0].cart_id;
                        this.showGraphicList = true;
                        this.getDiscount();

                        this.calculateTotals();
                    } else {
                        this.showGraphicList = false;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        correctPrice() {
            if (this.discountPercentage > 0) {
                this.graphics.forEach((item) => {
                    item.price = !!this.constantUnitPrice(item)
                        ? this.constantUnitPrice(item)
                        : parseFloat(
                              parseFloat(
                                  item.price * (1 - this.discountPercentage)
                              ).toFixed(2)
                          );
                    item.price = item.price * item.quantity;
                    this.totalPrice = this.totalPrice + item.price;
                    item.price = new Intl.NumberFormat("en-EN", {
                        style: "currency",
                        currency: "EUR",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }).format(item.price);
                });
            } else {
                this.graphics.forEach((item) => {
                    item.price = !!this.constantUnitPrice(item)
                        ? this.constantUnitPrice(item) * item.quantity
                        : parseFloat(parseFloat(item.price).toFixed(2)) *
                          item.quantity;
                    this.totalPrice = this.totalPrice + item.price;
                    item.price = new Intl.NumberFormat("en-EN", {
                        style: "currency",
                        currency: "EUR",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }).format(item.price);
                });
            }
            this.totalPrice = new Intl.NumberFormat("en-EN", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(this.totalPrice);
        },

        constantUnitPrice(graphic) {
            let price = null;
            if (graphic.fix_price) {
                price = graphic.fix_price;
            }

            if (graphic.pohoda_client_price) {
                price = graphic.pohoda_client_price;
            }

            if (graphic.fix_price && graphic.pohoda_client_price) {
                price = graphic.pohoda_client_price;
            }

            return price;
        },

        calculateTotals() {
            this.graphics.forEach((item) => {
                this.totalQuantity =
                    parseInt(this.totalQuantity) + parseInt(item.quantity);
                if (String(item.weight).indexOf(",") < 0) {
                    item.formattedWeight = parseFloat(item.weight);
                    if (String(item.weight).indexOf(".") < 0) {
                        item.weight = item.weight + ",0";
                    } else {
                        item.weight = String(item.weight).replace(".", ",");
                    }
                } else {
                    item.formattedWeight = parseFloat(
                        item.weight.replace(/,/, ".")
                    );
                }
                this.totalWeight =
                    parseFloat(this.totalWeight) +
                    item.formattedWeight * parseInt(item.quantity);
            });
            this.totalWeight = new Intl.NumberFormat("en-EN", {
                style: "decimal",
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            }).format(this.totalWeight);
        },

        addToCart() {
            let cartToAdd = {
                cart_id: this.cartId,
                client_id: this.profile.id,
                orderedByEmail: this.$store.state.profile.email,
            };
            axios
                .post("/addSavedCart", cartToAdd)
                .then((response) => {
                    var newTotalQuantity =
                        parseInt(this.totalQuantity) +
                        parseInt(this.cartCounter);
                    this.$store.dispatch("resetCartCounter");
                    this.updateCartCounter(newTotalQuantity);
                    this.scrollToTop();
                    if (response.data > 0) {
                        this.message = {
                            text:
                                this.appParams.staticTranslations[
                                    "carts.cart_activated"
                                ] +
                                " " +
                                this.appParams.staticTranslations[
                                    "carts.cart"
                                ] +
                                " " +
                                String(response.data),
                            type: "success",
                        };
                    } else {
                        this.message = {
                            text: this.appParams.staticTranslations[
                                "carts.items_added_active_cart"
                            ],
                            type: "success",
                        };
                    }
                    this.isAddDisabled = true;

                    setTimeout(() => {
                        this.message = null;
                        this.isAddDisabled = false;
                    }, 3000);
                })
                .catch((error) => {
                    console.log(error);
                    this.message = {
                        text: this.appParams.staticTranslations[
                            "carts.form_error"
                        ],
                        type: "danger",
                    };

                    setTimeout(() => {
                        this.message = null;
                    }, 3000);
                });
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        getDiscount() {
            axios
                .post("/getDiscount", { client_id: this.profile.id })
                .then((response) => {
                    this.pohodaPriceName = response.data.pohodaPriceName;
                    this.discountValue = response.data.discount;

                    if (this.pohodaPriceName) {
                        // this.discountValue = 0;
                    }

                    if (this.discountValue > 0) {
                        this.discountPercentage = this.discountValue / 100;
                    } else {
                        this.discountPercentage = 0;
                    }
                    this.correctPrice();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>
